import { useState, useEffect } from 'react';
import { supabase } from '../lib/supabase';
import { useAuth } from '../context/AuthContext';

const CATEGORIAS = [
  { key:'fluxo',     label:'Fluxo de mensagens', emoji:'💬', cor:'#4A90D9' },
  { key:'modelos',   label:'Modelos',             emoji:'📄', cor:'#6B2FA0' },
  { key:'material',  label:'Material de apoio',   emoji:'📚', cor:'#5BAD8F' },
  { key:'funcoes',   label:'Mapa de funções',     emoji:'🗺️', cor:'#C9A84C' },
  { key:'contratos', label:'Contratos',           emoji:'✍️', cor:'#D4789B' },
  { key:'senhas',    label:'Senhas e acessos',    emoji:'🔐', cor:'#9B7FD4' },
  { key:'processos', label:'Processos internos',  emoji:'⚙️', cor:'#0891b2' },
  { key:'outros',    label:'Outros',              emoji:'📁', cor:'#E05454' },
];
const PERFIS = ['admin','gestor','sdr','closer','adm','saude','infoprodutos'];

export default function Playbook() {
  const { usuario } = useAuth();
  const usuarioAtual = usuario?.nome || '';
  const perfilAtual = usuario?.perfil || 'sdr';
  const isGestorAdmin = ['admin','gestor'].includes(perfilAtual);

  const [colaboradoresNomes, setColaboradoresNomes] = useState(['Todos']);
  const [documentos, setDocumentos] = useState([]);
  const [carregando, setCarregando] = useState(true);
  const [docAberto, setDocAberto] = useState(null);
  const [modalNovo, setModalNovo] = useState(false);
  const [editandoDoc, setEditandoDoc] = useState(null);
  const [busca, setBusca] = useState('');
  const [filtroCategoria, setFiltroCategoria] = useState('');
  const [modoEdicao, setModoEdicao] = useState(false);
  const [conteudoEditando, setConteudoEditando] = useState('');
  const [form, setForm] = useState({ titulo:'', categoria:'fluxo', conteudo:'', tipo:'texto', link:'', acesso_perfis:['admin','gestor'], acesso_colaboradores:['Todos'], tags:[] });
  const [tagInput, setTagInput] = useState('');

  useEffect(() => {
    carregarDocumentos();
    supabase.from('colaboradores').select('nome').order('nome').then(({ data }) => {
      if (data) setColaboradoresNomes(['Todos', ...data.map(c => c.nome)]);
    });
  }, []);

  async function carregarDocumentos() {
    setCarregando(true);
    const { data } = await supabase.from('playbook').select('*').order('created_at', { ascending: false });
    if (data) setDocumentos(data);
    setCarregando(false);
  }

  const docsFiltrados = documentos.filter(d => {
    const temAcesso = (d.acesso_perfis||[]).includes(perfilAtual) || (d.acesso_colaboradores||[]).includes(usuarioAtual) || (d.acesso_colaboradores||[]).includes('Todos');
    const buscaOk = !busca || d.titulo?.toLowerCase().includes(busca.toLowerCase()) || (d.tags||[]).some(t=>t.toLowerCase().includes(busca.toLowerCase()));
    const catOk = !filtroCategoria || d.categoria === filtroCategoria;
    return temAcesso && buscaOk && catOk;
  });

  async function salvarDoc() {
    if (!form.titulo) return;
    if (editandoDoc) {
      const { data } = await supabase.from('playbook').update(form).eq('id', editandoDoc.id).select().single();
      if (data) setDocumentos(documentos.map(d=>d.id===editandoDoc.id?data:d));
    } else {
      const { data } = await supabase.from('playbook').insert([{ ...form, criado_por: usuarioAtual }]).select().single();
      if (data) setDocumentos([data, ...documentos]);
    }
    setModalNovo(false); setEditandoDoc(null);
    setForm({ titulo:'', categoria:'fluxo', conteudo:'', tipo:'texto', link:'', acesso_perfis:['admin','gestor'], acesso_colaboradores:['Todos'], tags:[] });
  }

  async function salvarEdicaoConteudo() {
    const { data } = await supabase.from('playbook').update({ conteudo: conteudoEditando }).eq('id', docAberto.id).select().single();
    if (data) { setDocumentos(documentos.map(d=>d.id===docAberto.id?data:d)); setDocAberto(data); }
    setModoEdicao(false);
  }

  function abrirDoc(doc) { setDocAberto(doc); setModoEdicao(false); setConteudoEditando(doc.conteudo||''); }

  function togglePerfilAcesso(perfil) {
    const atual = form.acesso_perfis||[];
    setForm({ ...form, acesso_perfis: atual.includes(perfil)?atual.filter(p=>p!==perfil):[...atual, perfil] });
  }

  function toggleColabAcesso(colab) {
    const atual = form.acesso_colaboradores||[];
    if (colab==='Todos') { setForm({ ...form, acesso_colaboradores:['Todos'] }); return; }
    const semTodos = atual.filter(c=>c!=='Todos');
    setForm({ ...form, acesso_colaboradores: semTodos.includes(colab)?semTodos.filter(c=>c!==colab):[...semTodos, colab] });
  }

  function adicionarTag() {
    if (!tagInput.trim()) return;
    setForm({ ...form, tags:[...(form.tags||[]), tagInput.trim()] });
    setTagInput('');
  }

  function renderMarkdown(texto) {
    if (!texto) return '';
    return texto.split('\n').map((linha,i) => {
      if (linha.startsWith('# ')) return <h2 key={i} style={{ fontSize:20, fontWeight:800, color:'var(--text-primary)', margin:'16px 0 8px', borderBottom:'2px solid var(--border)', paddingBottom:6 }}>{linha.slice(2)}</h2>;
      if (linha.startsWith('## ')) return <h3 key={i} style={{ fontSize:15, fontWeight:700, color:'var(--purple)', margin:'14px 0 6px' }}>{linha.slice(3)}</h3>;
      if (linha.startsWith('- ')) return <div key={i} style={{ display:'flex', gap:8, marginBottom:4 }}><span style={{ color:'var(--purple)', fontWeight:700 }}>•</span><span style={{ fontSize:13, color:'var(--text-secondary)', lineHeight:1.5 }}>{linha.slice(2)}</span></div>;
      if (linha.startsWith('⚠️')) return <div key={i} style={{ background:'#FEF3C7', border:'1px solid #C9A84C', borderRadius:6, padding:'8px 12px', margin:'8px 0', fontSize:12, color:'#92400e', fontWeight:600 }}>{linha}</div>;
      if (linha==='') return <div key={i} style={{ height:8 }} />;
      return <div key={i} style={{ fontSize:13, color:'var(--text-secondary)', lineHeight:1.6, marginBottom:2 }}>{linha}</div>;
    });
  }

  const catConfig = (key) => CATEGORIAS.find(c=>c.key===key)||CATEGORIAS[7];

  if (carregando) return <div style={{ padding:40, textAlign:'center', color:'var(--gray-400)' }}>Carregando playbook...</div>;

  return (
    <div>
      <div className="section-header"><h2 className="section-title">Playbook</h2><div className="section-line" /></div>

      <div className="filter-bar" style={{ marginBottom:20 }}>
        <input placeholder="🔍  Buscar por título ou tag..." value={busca} onChange={e=>setBusca(e.target.value)}
          style={{ flex:1, minWidth:200, padding:'8px 14px', border:'1.5px solid rgba(107,33,168,0.12)', borderRadius:10, fontSize:12.5, background:'#FAF8FF', color:'#1E0A3C', outline:'none', fontFamily:'Poppins,sans-serif' }} />
        <select value={filtroCategoria} onChange={e=>setFiltroCategoria(e.target.value)} className={`chip-select${filtroCategoria?' active':''}`}>
          <option value=''>Categoria</option>
          {CATEGORIAS.map(c => <option key={c.key} value={c.key}>{c.emoji} {c.label}</option>)}
        </select>
        {(busca||filtroCategoria) && (
          <button onClick={()=>{setBusca('');setFiltroCategoria('');}} style={{ padding:'7px 12px', border:'none', borderRadius:10, background:'#F3EBFF', color:'#7B2FBE', cursor:'pointer', fontSize:12, fontWeight:600, fontFamily:'Poppins,sans-serif' }}>✕ Limpar</button>
        )}
        <div style={{ flex:1 }} />
        {isGestorAdmin && <button onClick={()=>{setEditandoDoc(null);setForm({titulo:'',categoria:'fluxo',conteudo:'',tipo:'texto',link:'',acesso_perfis:['admin','gestor'],acesso_colaboradores:['Todos'],tags:[]});setModalNovo(true);}}
          style={{ background:'linear-gradient(135deg,#3F0051,#7B2FBE)', color:'white', border:'none', padding:'9px 22px', borderRadius:10, fontWeight:700, cursor:'pointer', fontSize:13, fontFamily:'Poppins,sans-serif', boxShadow:'0 4px 14px rgba(63,0,81,0.3)' }}>
          + Novo documento
        </button>}
      </div>

      <div style={{ display:'flex', gap:8, marginBottom:20, flexWrap:'wrap' }}>
        <button onClick={()=>setFiltroCategoria('')} style={{ padding:'6px 14px', borderRadius:20, border:`1px solid ${!filtroCategoria?'var(--purple)':'var(--border)'}`, background:!filtroCategoria?'var(--purple)':'transparent', color:!filtroCategoria?'white':'var(--text-secondary)', cursor:'pointer', fontSize:12, fontWeight:!filtroCategoria?700:400 }}>
          Todos ({docsFiltrados.length})
        </button>
        {CATEGORIAS.map(c => {
          const count = docsFiltrados.filter(d=>d.categoria===c.key).length;
          if (count===0) return null;
          return <button key={c.key} onClick={()=>setFiltroCategoria(c.key)} style={{ padding:'6px 14px', borderRadius:20, border:`1px solid ${filtroCategoria===c.key?c.cor:'var(--border)'}`, background:filtroCategoria===c.key?c.cor:'transparent', color:filtroCategoria===c.key?'white':'var(--text-secondary)', cursor:'pointer', fontSize:12, fontWeight:filtroCategoria===c.key?700:400 }}>
            {c.emoji} {c.label} ({count})
          </button>;
        })}
      </div>

      {docsFiltrados.length===0 && !carregando && (
        <div className="card" style={{ padding:40, textAlign:'center', color:'var(--gray-400)' }}>
          Nenhum documento encontrado. {isGestorAdmin && 'Clique em "+ Novo documento" para começar!'}
        </div>
      )}

      <div style={{ display:'grid', gridTemplateColumns:'repeat(3,1fr)', gap:14 }}>
        {docsFiltrados.map(doc => {
          const cat = catConfig(doc.categoria);
          return (
            <div key={doc.id} className="card" onClick={()=>abrirDoc(doc)}
              style={{ padding:20, cursor:'pointer', borderTop:`3px solid ${cat.cor}`, transition:'transform 0.15s' }}
              onMouseEnter={e=>{e.currentTarget.style.transform='translateY(-2px)';}} onMouseLeave={e=>{e.currentTarget.style.transform='translateY(0)';}}>
              <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start', marginBottom:10 }}>
                <span style={{ fontSize:24 }}>{cat.emoji}</span>
                <span style={{ background:cat.cor+'22', color:cat.cor, padding:'2px 8px', borderRadius:20, fontSize:10, fontWeight:700 }}>{cat.label}</span>
              </div>
              <div style={{ fontWeight:700, fontSize:14, color:'var(--text-primary)', marginBottom:6, lineHeight:1.3 }}>{doc.titulo}</div>
              <div style={{ fontSize:11, color:'var(--gray-400)', marginBottom:10 }}>Por {doc.criado_por} · {doc.created_at?.slice(0,10)}</div>
              {(doc.tags||[]).length>0 && <div style={{ display:'flex', gap:4, flexWrap:'wrap' }}>{doc.tags.map(t => <span key={t} style={{ background:'var(--bg-secondary)', border:'1px solid var(--border)', padding:'2px 7px', borderRadius:20, fontSize:10, color:'var(--text-secondary)' }}>{t}</span>)}</div>}
            </div>
          );
        })}
      </div>

      {/* Painel lateral */}
      {docAberto && (
        <div style={{ position:'fixed', inset:0, zIndex:1000, display:'flex' }}>
          <div style={{ flex:1, background:'rgba(0,0,0,0.4)' }} onClick={()=>setDocAberto(null)} />
          <div style={{ width:620, background:'#ffffff', borderLeft:'1px solid var(--border)', overflowY:'auto', padding:32, boxShadow:'-4px 0 24px rgba(0,0,0,0.15)' }}>
            <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start', marginBottom:20 }}>
              <div style={{ flex:1, marginRight:12 }}>
                <div style={{ fontSize:11, color:catConfig(docAberto.categoria).cor, fontWeight:700, marginBottom:4, textTransform:'uppercase' }}>{catConfig(docAberto.categoria).emoji} {catConfig(docAberto.categoria).label}</div>
                <h2 style={{ margin:0, fontSize:18, color:'var(--text-primary)' }}>{docAberto.titulo}</h2>
                <div style={{ fontSize:11, color:'var(--gray-400)', marginTop:4 }}>Por {docAberto.criado_por} · {docAberto.created_at?.slice(0,10)}</div>
              </div>
              <div style={{ display:'flex', gap:8, flexShrink:0 }}>
                {isGestorAdmin && <>
                  <button onClick={()=>setModoEdicao(!modoEdicao)} style={{ background:modoEdicao?'#E05454':'var(--purple)', color:'white', border:'none', padding:'6px 12px', borderRadius:6, cursor:'pointer', fontSize:12, fontWeight:600 }}>{modoEdicao?'Cancelar':'Editar'}</button>
                  <button onClick={()=>{setEditandoDoc(docAberto);setForm({titulo:docAberto.titulo,categoria:docAberto.categoria,conteudo:docAberto.conteudo,tipo:docAberto.tipo,link:docAberto.link||'',acesso_perfis:docAberto.acesso_perfis||['admin'],acesso_colaboradores:docAberto.acesso_colaboradores||['Todos'],tags:docAberto.tags||[]});setModalNovo(true);setDocAberto(null);}}
                    style={{ background:'var(--bg-secondary)', color:'var(--text-secondary)', border:'1px solid var(--border)', padding:'6px 12px', borderRadius:6, cursor:'pointer', fontSize:12 }}>Config</button>
                </>}
                <button onClick={()=>setDocAberto(null)} style={{ background:'transparent', border:'none', fontSize:20, cursor:'pointer', color:'var(--gray-400)' }}>×</button>
              </div>
            </div>
            {(docAberto.tags||[]).length>0 && <div style={{ display:'flex', gap:6, marginBottom:16, flexWrap:'wrap' }}>{docAberto.tags.map(t => <span key={t} style={{ background:'var(--bg-secondary)', border:'1px solid var(--border)', padding:'3px 10px', borderRadius:20, fontSize:11, color:'var(--text-secondary)' }}>{t}</span>)}</div>}
            {docAberto.link && <a href={docAberto.link} target="_blank" rel="noreferrer" style={{ display:'flex', alignItems:'center', gap:8, padding:'10px 14px', background:'#EBF4FF', border:'1px solid #4A90D9', borderRadius:8, marginBottom:16, textDecoration:'none', color:'#4A90D9', fontSize:13, fontWeight:600 }}>🔗 Abrir link externo</a>}
            {modoEdicao ? (
              <div>
                <textarea value={conteudoEditando} onChange={e=>setConteudoEditando(e.target.value)}
                  style={{ width:'100%', minHeight:400, padding:'12px', border:'1px solid var(--border)', borderRadius:8, fontSize:13, fontFamily:'monospace', background:'var(--bg-secondary)', color:'var(--text-primary)', boxSizing:'border-box', resize:'vertical', lineHeight:1.6 }} />
                <div style={{ display:'flex', gap:10, marginTop:12 }}>
                  <button onClick={salvarEdicaoConteudo} style={{ flex:1, background:'var(--purple)', color:'white', border:'none', padding:'10px', borderRadius:7, fontWeight:700, cursor:'pointer', fontSize:13 }}>Salvar</button>
                  <button onClick={()=>setModoEdicao(false)} style={{ flex:1, background:'transparent', border:'1px solid var(--border)', padding:'10px', borderRadius:7, cursor:'pointer', color:'var(--text-secondary)', fontSize:13 }}>Cancelar</button>
                </div>
              </div>
            ) : <div style={{ lineHeight:1.6 }}>{renderMarkdown(docAberto.conteudo)}</div>}
          </div>
        </div>
      )}

      {/* Modal novo/editar */}
      {modalNovo && (
        <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.5)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:2000 }}>
          <div className="card" style={{ width:580, padding:32, maxHeight:'90vh', overflowY:'auto' }}>
            <div style={{ display:'flex', justifyContent:'space-between', marginBottom:20 }}>
              <h3 style={{ margin:0, color:'var(--purple)' }}>{editandoDoc?'Editar':'Novo'} documento</h3>
              <button onClick={()=>setModalNovo(false)} style={{ background:'transparent', border:'none', fontSize:20, cursor:'pointer', color:'var(--gray-400)' }}>×</button>
            </div>
            <div style={{ marginBottom:14 }}>
              <label style={{ display:'block', fontSize:11, fontWeight:600, color:'var(--gray-400)', marginBottom:5, textTransform:'uppercase' }}>Título</label>
              <input value={form.titulo} onChange={e=>setForm({...form,titulo:e.target.value})}
                style={{ width:'100%', padding:'9px 12px', border:'1px solid var(--border)', borderRadius:6, fontSize:13, background:'var(--bg-secondary)', color:'var(--text-primary)', boxSizing:'border-box' }} />
            </div>
            <div style={{ marginBottom:14 }}>
              <label style={{ display:'block', fontSize:11, fontWeight:600, color:'var(--gray-400)', marginBottom:5, textTransform:'uppercase' }}>Categoria</label>
              <select value={form.categoria} onChange={e=>setForm({...form,categoria:e.target.value})}
                style={{ width:'100%', padding:'9px 12px', border:'1px solid var(--border)', borderRadius:6, fontSize:13, background:'var(--bg-secondary)', color:'var(--text-primary)' }}>
                {CATEGORIAS.map(c => <option key={c.key} value={c.key}>{c.emoji} {c.label}</option>)}
              </select>
            </div>
            <div style={{ marginBottom:14 }}>
              <label style={{ display:'block', fontSize:11, fontWeight:600, color:'var(--gray-400)', marginBottom:5, textTransform:'uppercase' }}>Conteúdo (Markdown)</label>
              <textarea value={form.conteudo} onChange={e=>setForm({...form,conteudo:e.target.value})} rows={8}
                style={{ width:'100%', padding:'9px 12px', border:'1px solid var(--border)', borderRadius:6, fontSize:13, fontFamily:'monospace', background:'var(--bg-secondary)', color:'var(--text-primary)', boxSizing:'border-box', resize:'vertical' }} />
            </div>
            <div style={{ marginBottom:14 }}>
              <label style={{ display:'block', fontSize:11, fontWeight:600, color:'var(--gray-400)', marginBottom:5, textTransform:'uppercase' }}>Link externo (opcional)</label>
              <input value={form.link} onChange={e=>setForm({...form,link:e.target.value})} placeholder="https://..."
                style={{ width:'100%', padding:'9px 12px', border:'1px solid var(--border)', borderRadius:6, fontSize:13, background:'var(--bg-secondary)', color:'var(--text-primary)', boxSizing:'border-box' }} />
            </div>
            <div style={{ marginBottom:14 }}>
              <label style={{ display:'block', fontSize:11, fontWeight:600, color:'var(--gray-400)', marginBottom:8, textTransform:'uppercase' }}>Acesso por perfil</label>
              <div style={{ display:'flex', gap:6, flexWrap:'wrap' }}>
                {PERFIS.map(p => { const ativo=(form.acesso_perfis||[]).includes(p); return <button key={p} onClick={()=>togglePerfilAcesso(p)} style={{ padding:'5px 12px', borderRadius:20, border:`1px solid ${ativo?'var(--purple)':'var(--border)'}`, background:ativo?'var(--purple)':'transparent', color:ativo?'white':'var(--text-secondary)', cursor:'pointer', fontSize:12, fontWeight:ativo?700:400 }}>{p}</button>; })}
              </div>
            </div>
            <div style={{ marginBottom:14 }}>
              <label style={{ display:'block', fontSize:11, fontWeight:600, color:'var(--gray-400)', marginBottom:8, textTransform:'uppercase' }}>Acesso por colaborador</label>
              <div style={{ display:'flex', gap:6, flexWrap:'wrap' }}>
                {colaboradoresNomes.map(c => { const ativo=(form.acesso_colaboradores||[]).includes(c); return <button key={c} onClick={()=>toggleColabAcesso(c)} style={{ padding:'5px 12px', borderRadius:20, border:`1px solid ${ativo?'#4A90D9':'var(--border)'}`, background:ativo?'#4A90D9':'transparent', color:ativo?'white':'var(--text-secondary)', cursor:'pointer', fontSize:12, fontWeight:ativo?700:400 }}>{c}</button>; })}
              </div>
            </div>
            <div style={{ marginBottom:20 }}>
              <label style={{ display:'block', fontSize:11, fontWeight:600, color:'var(--gray-400)', marginBottom:8, textTransform:'uppercase' }}>Tags</label>
              <div style={{ display:'flex', gap:8, marginBottom:8 }}>
                <input value={tagInput} onChange={e=>setTagInput(e.target.value)} onKeyDown={e=>e.key==='Enter'&&adicionarTag()} placeholder="Digite e Enter..."
                  style={{ flex:1, padding:'8px 12px', border:'1px solid var(--border)', borderRadius:6, fontSize:13, background:'var(--bg-secondary)', color:'var(--text-primary)' }} />
                <button onClick={adicionarTag} style={{ background:'var(--purple)', color:'white', border:'none', padding:'8px 14px', borderRadius:6, cursor:'pointer', fontWeight:600 }}>+</button>
              </div>
              <div style={{ display:'flex', gap:6, flexWrap:'wrap' }}>
                {(form.tags||[]).map(t => <div key={t} style={{ display:'flex', alignItems:'center', gap:4, background:'var(--bg-secondary)', border:'1px solid var(--border)', padding:'3px 8px', borderRadius:20 }}>
                  <span style={{ fontSize:12, color:'var(--text-secondary)' }}>{t}</span>
                  <button onClick={()=>setForm({...form,tags:(form.tags||[]).filter(x=>x!==t)})} style={{ background:'transparent', border:'none', cursor:'pointer', color:'var(--gray-400)', fontSize:14, lineHeight:1 }}>×</button>
                </div>)}
              </div>
            </div>
            <div style={{ display:'flex', gap:10 }}>
              <button onClick={salvarDoc} style={{ flex:1, background:'var(--purple)', color:'white', border:'none', padding:'11px', borderRadius:7, fontWeight:700, cursor:'pointer', fontSize:14 }}>Salvar</button>
              <button onClick={()=>setModalNovo(false)} style={{ flex:1, background:'transparent', border:'1px solid var(--border)', padding:'11px', borderRadius:7, cursor:'pointer', color:'var(--text-secondary)', fontSize:14 }}>Cancelar</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
